import _ from 'underscore';

import {DataFrame, DataFrameColumnDef, DataFrameRow} from 'data-frames/DataFrameTypes';
import {DataFrameValueAccessor} from 'data-frames/util/createAccessors';
import {makeStructuredTableColumn} from 'notebook/structured-tables/util/StructuredTableColumnUtil';
import {Cell} from 'notebook/tables/constants/CellConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';
import {JSONValue} from 'util/Types';

import {DEFAULT_COLUMN_WIDTH} from '../DataFrameTableEditableConstants';
import {
  DataFrameToTableColumnInfoInitializer,
  BaseColumnConstraint,
  BaseStructuredTableColumn,
} from '../DataFrameTableEditableTypes';

export default function jsonColumnInfoInitializer(
  {type: {isNullable}}: DataFrameColumnDef,
  dataFrame: DataFrame,
  baseColumnConstraint: BaseColumnConstraint,
  baseStructuredTableColumn: BaseStructuredTableColumn,
  baseAccessor: DataFrameValueAccessor
): ReturnType<DataFrameToTableColumnInfoInitializer> {
  function rawValueAccessor(row: DataFrameRow): string {
    const value = baseAccessor(row);

    if (value == null) {
      return 'None';
    }

    if (typeof value === 'object') {
      return JSON.stringify(value);
    }

    return String(value);
  }

  const options = _.unique([
    ...(isNullable ? ['None'] : []),
    ...dataFrame.rows.map((row) => rawValueAccessor(row)),
  ]);

  return {
    columnConstraint: {
      ...baseColumnConstraint,
      columnDefinition: {
        type: TableColumnType.OPTION_SEARCH_SELECTOR,
        options,
        isRequired: !isNullable,
      },
      structuredTableColumn: {
        ...makeStructuredTableColumn({
          ...baseStructuredTableColumn,
          columnType: TableColumnType.OPTION_SEARCH_SELECTOR,
        }),
        ...baseStructuredTableColumn,
      },
    },
    dataFrameValueToTableCell: (row: DataFrameRow): Cell => {
      const rawValue = rawValueAccessor(row);

      return {
        text: '',
        typedValue: {
          type: BaseTypedValueType.STRING,
          rawValue,
        },
      };
    },
    tableCellToDataFrameValue: ({text, typedValue}: Cell): JSONValue => {
      if (typedValue != null && typedValue.type === BaseTypedValueType.STRING) {
        for (const row of dataFrame.rows) {
          if (typedValue.rawValue === rawValueAccessor(row)) {
            return baseAccessor(row);
          }
        }
      }

      for (const row of dataFrame.rows) {
        if (text === rawValueAccessor(row)) {
          return baseAccessor(row);
        }
      }

      return null;
    },
    width: DEFAULT_COLUMN_WIDTH,
  };
}
